export default __webpack_public_path__ + "static/calidad-de-la-gestion-mobile-5d886878c882a6d48e24a5cc991641a1.svg";